<template>
    <div>
        <PreparingCharger
            v-if="isShowPreparing"
            :subtitle="preparingSubtitle"
        ></PreparingCharger>
    </div>
</template>

<script>
import PreparingCharger from "../../components/loading/PreparingCharger.vue";
import { confirmBalancePayment, borrow } from "../../api/logined";
import { borrowWithStationBusyRetry } from "@/services/borrowRetry";

export default {
    components: { PreparingCharger },
    data() {
        return {
            isShowPreparing: false,
            internalId: undefined,
            deviceCode: undefined,
            borrowStationBusyWaiting: false,
        };
    },
    computed: {
        preparingSubtitle() {
            return this.borrowStationBusyWaiting
                ? this.$t("m.preparingStationBusySubtitle")
                : "";
        },
    },
    created() {
        const storeInternalId = this.$store.getters["appConfig/internal_id"];
        const params = new URLSearchParams(window.location.search || "");
        const queryInternalId = params.get("internalId") || params.get("internal_id");
        this.internalId = storeInternalId || queryInternalId || undefined;
        if (this.internalId && this.internalId !== storeInternalId) {
            this.$store.commit("appConfig/SET_INTERNAL_ID", this.internalId);
        }
        this.deviceCode = this.$store.getters["appConfig/device_code"];
    },
    mounted() {
        this.handleLoad();
    },
    methods: {
        handleLoad() {
            if (!this.internalId) {
                this.$router.push({ name: "payment_select" });
                return;
            }
            if (window.self !== window.parent) {
                const currentUrl = window.location.href;
                window.parent.location = currentUrl;
                this.completePaymentOrder();
                return;
            }
            this.completePaymentOrder();
        },
        async completePaymentOrder() {
            this.isShowPreparing = true;
            this.showLoading();
            try {
                while (true) {
                    try {
                        await confirmBalancePayment({
                            internal_id: this.internalId,
                            request_from: 1,
                        });
                        break;
                    } catch (error) {
                        if (error?.code === 80801) {
                            throw new Error(error.message || "Unknown error");
                        }
                        await new Promise((resolve) => setTimeout(resolve, 2000));
                    }
                }
                await borrowWithStationBusyRetry(
                    () => borrow({
                        code: this.deviceCode,
                    }),
                    {
                        onStationBusyChange: (waiting) => {
                            this.borrowStationBusyWaiting = waiting;
                        },
                    }
                );
                this.$router.push({ name: "borrow_success" });
            } catch (error) {
                this.toast(this.$t("tMsg.paymentFailed") + ": " + error.message, { persistent: !!error?.message });
                this.$router.push({ name: "payment_select" });
            } finally {
                this.borrowStationBusyWaiting = false;
                this.isShowPreparing = false;
                this.hideLoading();
            }
        },
    },
};
</script>
